<template>
    <div>
        <div v-show="show">
            <v-scale-transition>
                <v-card class="mainVcard">
                    <v-card-text>
                        <v-tabs
                            ref="tabs"
                            v-model="tab"
                            background-color="#00BFA5"
                            centered
                            dark
                            style="height: 40px"
                        >
                            <v-tabs-slider />
                            <v-btn
                                v-if="!isSigned"
                                text
                                style="height: 40px; position: absolute; right: 100px;"
                                @click="handleSignFile()"
                            >
                                sign
                            </v-btn>
                            <v-btn
                                v-if="isSigned && canBeExtended"
                                text
                                style="height: 40px; position: absolute; right: 100px;"
                                @click="handleExtension()"
                            >
                                request for extension
                            </v-btn>
                            <v-btn
                                text
                                style="height: 40px; position: absolute; right: 0;"
                                @click="closeDialog"
                            >
                                close
                            </v-btn>
                            <v-tab
                                v-show="isEndorsementExists"
                                style="height: 40px"
                                href="#tab-1"
                                @mouseup="showEndorsement()"
                            >
                                Endorsement
                            </v-tab>
                            <v-tab
                                v-show="isConfirmationExists"
                                style="height: 40px"
                                href="#tab-2"
                                @mouseup="showConfirmation()"
                            >
                                Confirmation
                            </v-tab>
                            <v-btn
                                text
                                style="margin-top: 2px;"
                                @click="handleShowMembers"
                            >
                                Members
                            </v-btn>
                            <v-btn
                                text
                                style="margin-top: 2px;"
                                @click="handleShowHistory"
                            >
                                History
                            </v-btn>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item
                                v-show="isEndorsementExists"
                                value="tab-1"
                            >
                                <v-card flat class="fullscreen-card">
                                    <v-card-text class="fullscreen-card-text">
                                        <iframe
                                            ref="fileObject1"
                                            :src="fileObject1 !== true ? fileObject1 : 'about:blank'"
                                            type="application/pdf"
                                            width="100%"
                                            height="100%"
                                            class="fullscreen-object"
                                        ><p>No PDF available</p></iframe>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item
                                v-show="isConfirmationExists"
                                value="tab-2"
                            >
                                <v-card flat class="fullscreen-card">
                                    <v-card-text class="fullscreen-card-text">
                                        <iframe
                                            ref="fileObject2"
                                            :src="fileObject2 !== true ? fileObject2 : 'about:blank'"
                                            type="application/pdf"
                                            width="100%"
                                            height="100%"
                                            class="fullscreen-object"
                                        ><p>No PDF available</p></iframe>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-scale-transition>
        </div>
        <RequestForExtension
            :show="extension.show"
            :data="extension.date"
            :info="data && data.information"
            :notif="notif"
            @extensionDate="handleExtension"
            @closeDialog="extension.show=false"
            @closeDialogWhenSuccessExtension="handleCloseDialog"
        />
        <LetterMembers
            :show="members.show"
            :data="members.data"
            :notif="notif"
            :require-pdf-update="requirePdfUpdate"
            @closeDialog="members.show = false"
        />
        <HistoryPage
            :show="history.show"
            :data="history.data"
            @closeDialog="history.show = false"
        />
    </div>
</template>

<script>
import { base64ToBlob } from '../../../../../../utils/helpers'
import HistoryPage from './Extension/HistoryPage.vue'
import RequestForExtension from './Extension/RequestForExtension.vue'
import LetterMembers from './LetterMembers/LetterMembers.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: { RequestForExtension, HistoryPage, LetterMembers },
    props: ['data', 'show', 'showingId', 'screen_width', 'notif'],
    data: () => ({
        requirePdfUpdate: { value: false },
        extension: {
            date: null,
            show: false
        },
        history: {
            data: null,
            show: false
        },
        members: {
            data: null,
            show: false
        },
        fileObject1: null,
        fileObject2: null,
        loading: false,
        tab: null,
        save_disabled: false
    }),
    computed: {
        ...mapGetters(['signEndorsementConfirmationData']),
        isSigned() {
            return this.data && this.data.information && this.data.information.SIGNED
        },
        canBeExtended() {
            return this.data && this.data.information && this.data.information.EXTENSION_COUNT < 2
        },
        isEndorsementExists() {
            return this.data && this.data.endorsement && this.data.endorsement ? true : false
        },
        isConfirmationExists() {
            return this.data && this.data.confirmation && this.data.confirmation ? true : false
        }
    },
    watch: {
        'members.show'(newVal) {
            if (!newVal && this.requirePdfUpdate.value) {
                this.requirePdfUpdate.value = false
                this.closeDialog()
                this.$emit('reopenPdfViewer')
            }
        },
        signEndorsementConfirmationData(newVal) {
            if (newVal && newVal.status === 200) {
                this.closeDialog()
                this.listEndorsementConfirmation()
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = 'Ok'
                this.notif.show = true
                this.notif.dismissible = true
                this.$emit('reopenPdfViewer')
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
                this.notif.dismissible = true
            }
        },
        show(newVal) {
            if (newVal) {
                if (this.isEndorsementExists) {
                    this.showEndorsement()
                } else if (this.isConfirmationExists) {
                    this.showConfirmation()
                }
            }
        }
    },
    methods: {
        ...mapActions(['signEndorsementConfirmation', 'listEndorsementConfirmation']),
        handleShowHistory() {
            this.history.data = this.data.information
            this.history.show = !this.history.show
        },
        handleShowMembers() {
            this.members.data = this.data.information
            this.members.show = !this.members.show
        },
        handleCloseDialog() {
            this.extension.show = false
            this.closeDialog()
        },
        handleExtendEndorsement(date) {
            this.extension.date = date
        },
        handleExtension() {
            this.extension.show = true
        },
        handleSignFile() {
            this.signEndorsementConfirmation({ ID: this.showingId })
        },
        closeDialog() {
            this.fileObject1 = false
            this.fileObject2 = false
            this.save_disabled = false
            this.loading = false
            this.tab = null
            this.$emit('closePdfViewer')
        },
        async showEndorsement() {
            if (!this.fileObject1) {
                this.tab = 'tab-1'
                await this.$nextTick()
                await this.waitForTransitionEnd(this.$refs.tabs.$el)
                this.fileObject1 = true
                await this.$nextTick()
                this.fetchData(this.data && this.data.endorsement && this.data.endorsement, 'fileObject1')
            }
        },
        async showConfirmation() {
            if (!this.fileObject2) {
                this.tab = 'tab-2'
                await this.$nextTick()
                await this.waitForTransitionEnd(this.$refs.tabs.$el)
                this.fileObject2 = true
                await this.$nextTick()
                this.fetchData(this.data && this.data.confirmation && this.data.confirmation, 'fileObject2')
            }
        },
        async fetchData(data, ref) {
            return new Promise((resolve, reject) => {
                try {
                    const blob = base64ToBlob(data, 'application/pdf')
                    const url = URL.createObjectURL(blob)
                    this.$nextTick(() => {
                        if (this.$refs[ref]) {
                            this.$refs[ref].scrollTop = 0
                            this.$refs[ref].src = url
                            resolve()
                        } else {
                            reject( new Error( 'File Object reference not available: ' + ref ) )
                        }
                    })
                } catch (error) {
                    reject(new Error('Something went wrong: ' + error.message))
                }
            })
        },
        // Define a function to wait for transition end
        waitForTransitionEnd(element) {
            return new Promise((resolve) => {
                const onTransitionEnd = () => {
                    element.removeEventListener(
                        'transitionend',
                        onTransitionEnd
                    )
                    resolve()
                }
                element.addEventListener('transitionend', onTransitionEnd)
            })
        }
    }
}
</script>

<style scoped>
.mainVcard {
    top: 3%;
    bottom: 3%;
    left: 5%;
    position: fixed !important;
    z-index: 240 !important;
    width: 100%;
    max-width: 90vw;
    height: 100%;
    max-height: 95vh;
}
.v-tab--active {
    font-weight: 700;
}
.fullscreen-card {
    width: 100%;
    height: 84vh; /* Full viewport height */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.fullscreen-card-text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
}
.fullscreen-object {
    width: 100%;
    height: 100%;
}
</style>
